import { useCallback, useMemo } from 'react';
import { toast } from 'react-toastify';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import useBoolean from 'src/hooks/useBoolean';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import { useReopenReceiptMutation } from 'src/services/receipt';

const ReopenReceipt = () => {
  const {
    receiptData,
    recId,
    isCurrentDocLinked,
    isPoOpen,
    hasCompletedLinkedInvoice,
    getMessages,
    isReceiptActionButtonsDisabled,
    refreshPage,
  } = useReceiptDetails();
  const {
    value: isReopenReceipt,
    setTrue: enableIsReopenReceipt,
    setFalse: disableIsReopenReceipt,
  } = useBoolean();
  const { mutateAsync: reopenReceiptMutation } = useReopenReceiptMutation();
  const { reOpenReceipt } = receiptData;

  const messages = useMemo(
    () => [...(isCurrentDocLinked && isPoOpen ? ['Receipt Linked to an Invoice'] : [])],
    [isCurrentDocLinked, isPoOpen]
  );

  const isDisabled = isReceiptActionButtonsDisabled(!!messages.length);

  const handleReopenReceipt = useCallback(async () => {
    enableIsReopenReceipt();
    try {
      await reopenReceiptMutation([Number(recId)]);
      toast.success('Receipt Re-opened successfully!');
      refreshPage();
    } catch (error) {
      console.error(error);
    } finally {
      disableIsReopenReceipt();
    }
  }, [disableIsReopenReceipt, enableIsReopenReceipt, recId, refreshPage, reopenReceiptMutation]);

  return (
    <>
      {!hasCompletedLinkedInvoice && (
        <PopUp
          content={<PopUpContentWrapper type="Error" contents={getMessages(messages)} />}
          show={isDisabled}
        >
          <Button
            onClick={handleReopenReceipt}
            color="dark"
            buttonState={reOpenReceipt}
            disabled={isDisabled}
            loading={isReopenReceipt}
          >
            Re-Open
          </Button>
        </PopUp>
      )}
    </>
  );
};

export default ReopenReceipt;
